import { ActionKeys } from '../../constants';
import * as D from '../../deps';
import PlaybackWorkers from '../workers';

export default [
  {
    actionType: D.Constants.UseCases.ActionTypes.UPDATE_STATION,
    handler: PlaybackWorkers.updateStation,
    concur: 'takeEvery',
  },
  {
    actionType: ActionKeys.UPDATE_SERVER_PLAYBACK_PAUSED,
    handler: PlaybackWorkers.updateServerPlaybackPaused,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.INTENT_PLAY_TRACK,
    handler: PlaybackWorkers.onIntentToPlay,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.PLAYBACK_TRACK_ENDED,
    handler: PlaybackWorkers.onTrackEnd,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.UseCases.ActionTypes.CHECK_IS_PLAYABLE_SOURCE,
    handler: PlaybackWorkers.checkIsPlayableSource,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.PLAYBACK_LOG_TRACK_STARTED,
    handler: PlaybackWorkers.callTrackStarted,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Playback.ActionTypes.PLAYBACK_LOG_TRACK_RESUMED,
    handler: PlaybackWorkers.callTrackResumed,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Login.LoginActions.LOGIN_FLOW_COMPLETE,
    handler: PlaybackWorkers.forceActiveListenerWhenAudioIsPlaying,
    concur: 'takeEvery',
  },
  {
    actionType: ActionKeys.START_INITIAL_PLAYBACK,
    handler: PlaybackWorkers.startInitialPlayback,
    concur: 'takeOnly',
  },
  {
    actionType: ActionKeys.HANDLE_ARTIST_AUDIO_MESSAGE_CTA,
    handler: PlaybackWorkers.handleArtistAudioMessageCTA,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.TRACK_END_ERROR,
    handler: PlaybackWorkers.trackEndError,
    concur: 'takeLatest',
  },
];
